import React from 'react'
import LinkButton from '../../../UniformComponents/LinkButton'

import './login-layout.scss'

const LoginLayout = (props) => {
    const { children } = props
    return (
        <div id="login">
            <div className="left-container">
                <LinkButton
                    cssClass="explori-btn primary regular"
                    label="Explori site"
                    icon="fa-sharp fa-regular fa-arrow-left"
                    href="https://www.explori.com/"
                    isExternal
                    target="_blank"
                />
                <div className="half-overlay" />
                {children}
            </div>
        </div>
    )
}

export default LoginLayout
